import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  Lambourg Renovations, LLC
                  <span></span>
                </h1>
                <p>Home renovations in the Greater Houston area.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
